export default function BookingReviewShimmer() {
    return (
        <div className="flex flex-col lg:flex-row gap-6 animate-pulse bg-gray-50  rounded-xl mt-2">
            {/* Left Section */}
            <div className="flex-1 bg-white rounded-xl p-4 shadow-sm">
                {/* Title */}
                <div className="h-6 w-48 bg-gray-200 rounded mb-4"></div>

                {/* Hotel Name */}
                <div className="h-5 w-64 bg-gray-200 rounded mb-2"></div>
                {/* Address */}
                <div className="h-4 w-80 bg-gray-200 rounded mb-6"></div>

                {/* Check-in / Check-out */}
                <div className="flex justify-between mb-4">
                    <div>
                        <div className="h-4 w-16 bg-gray-200 rounded mb-2"></div>
                        <div className="h-5 w-24 bg-gray-200 rounded"></div>
                    </div>
                    <div>
                        <div className="h-4 w-16 bg-gray-200 rounded mb-2"></div>
                        <div className="h-5 w-24 bg-gray-200 rounded"></div>
                    </div>
                </div>

                {/* Summary Line */}
                <div className="h-4 w-56 bg-gray-200 rounded mb-6"></div>
                <hr className="my-4" />

                {/* Room Info Card */}
                <div className="border rounded-xl p-4 mb-6">
                    <div className="h-5 w-64 bg-gray-200 rounded mb-2"></div>
                    <div className="h-4 w-40 bg-gray-200 rounded mb-4"></div>
                    <div className="h-4 w-28 bg-gray-200 rounded"></div>
                </div>

                {/* Traveler Details Section */}
                <div className="h-5 w-72 bg-gray-200 rounded mb-2"></div>
                <div className="h-4 w-60 bg-gray-200 rounded"></div>
            </div>

            {/* Right Section - Fare Details */}
            <div className="w-full lg:w-1/3 bg-white rounded-xl p-6 shadow-sm">
                <div className="h-6 w-40 bg-gray-200 rounded mb-4"></div>

                {/* Fare Lines */}
                <div className="space-y-3 mb-4">
                    {[1, 2, 3, 4].map((i) => (
                        <div key={i} className="flex justify-between">
                            <div className="h-4 w-32 bg-gray-200 rounded"></div>
                            <div className="h-4 w-16 bg-gray-200 rounded"></div>
                        </div>
                    ))}
                </div>

                <hr className="my-4" />

                {/* Price after Discount */}
                <div className="flex justify-between mb-2">
                    <div className="h-4 w-36 bg-gray-200 rounded"></div>
                    <div className="h-4 w-20 bg-gray-200 rounded"></div>
                </div>

                {/* Total Amount */}
                <div className="flex justify-between items-center mb-6">
                    <div className="h-5 w-28 bg-gray-200 rounded"></div>
                    <div className="h-6 w-24 bg-gray-300 rounded"></div>
                </div>

                {/* Check-in/Out Info */}
                <div className="h-4 w-64 bg-gray-200 rounded mb-2"></div>
                <div className="h-3 w-40 bg-gray-200 rounded"></div>
            </div>
        </div>
    );
}
